module.exports = __webpack_public_path__ + "static/icons/icon-thumbs-up-solid-62bec1cab3de8e90a95eb29e6fb7d9a8.svg";